import { Download } from "lucide-react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

/**
 * "Download .md" — one button shape for every markdown export in the room (transcript,
 * meeting notes, and each generated artifact). The href is a same-origin GET, so the
 * session cookie rides along and the server's Content-Disposition names the file; the bare
 * `download` attribute just tells the browser to save rather than navigate.
 */
export function DownloadMdButton({
  href,
  label = "Download .md",
  title = "Download as markdown",
  className,
}: {
  href: string;
  label?: string;
  title?: string;
  className?: string;
}) {
  return (
    <Button asChild size="sm" variant="outline" className={cn("shrink-0", className)}>
      <a href={href} download title={title}>
        <Download className="size-3.5" />
        {label}
      </a>
    </Button>
  );
}
